// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Search\\&Options_inputMain__bI4tC img {
    display: none;
}

@media screen and (max-width: 768px) {
    .Search\\&Options_inputMain__bI4tC {
        padding: 3px 5px;
        border-radius: 10px;
        width: 48%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        /* background-color: #0094ff; */
        background-color: inherit;
        border: 1px solid black;
        margin: 2px;

    }

    .Search\\&Options_inputTypeDate__oF8H7 {
        border: 1px solid #aaa;
        border-radius: 3px;
        padding: 5px;
        background-color: transparent;
        margin-left: 3px;
        border: none;
        /* width: 29px; */
        font-size: 13px;
       
        background: blue;
    }

    .Search\\&Options_selector__jQWgY {
        margin-top: 5px;
        border: 1px solid black;
        outline: none;
        font-size: 13px;
        width: 48%;
        margin-bottom: 0px !important;
    }

    .Search\\&Options_date__WawNV{
      color: black;
      font-size: 13px;
    }

    .Search\\&Options_inputMain__bI4tC input {
        background-color: inherit;
        border: none;
        outline: none;
        width: 90%;
        /* color: white; */
        color: black;
        margin-bottom: 0px !important;
        padding: 0px !important;
    }

    .Search\\&Options_inputMain__bI4tC img {
        width: 11%;
        display: block;
    }

    .Search\\&Options_inputMain__bI4tC input::placeholder {
        /* color: white; */
        color: black;
        font-size: 11px;
    }

}

  .Search\\&Options_inputMain__bI4tC img {
      display: none;
  }

  @media screen and (max-width: 768px) {
      .Search\\&Options_inputMain__bI4tC {
          padding: 3px 5px;
          border-radius: 10px;
          width: 48%;
          display: flex;
          justify-content: space-around;
          align-items: center;
          /* background-color: #0094ff; */
          background-color: inherit;
          border: 1px solid black;
          margin: 2px;

      }

      .Search\\&Options_inputTypeDate__oF8H7 {
          border: 1px solid #aaa;
          border-radius: 3px;
          padding: 5px;
          background-color: transparent;
          margin-left: 3px;
          border: none;
          /* width: 29px; */
          font-size: 13px;
         
          background: blue;
      }

      .Search\\&Options_selector__jQWgY {
          margin-top: 5px;
          border: 1px solid black;
          outline: none;
          font-size: 12px;
          width: 48%;
          margin-bottom: 0px !important;
      }

      .Search\\&Options_date__WawNV{
        color: black;
        font-size: 13px;
      }

      .Search\\&Options_inputMain__bI4tC input {
          background-color: inherit;
          border: none;
          outline: none;
          width: 90%;
          /* color: white; */
          color: black;
          margin-bottom: 0px !important;
          padding: 0px !important;
      }

      .Search\\&Options_inputMain__bI4tC img {
          width: 10%;
          display: block;
      }

      .Search\\&Options_inputMain__bI4tC input::placeholder {
          /* color: white; */
          color: black;
          font-size: 11px;
      }

  }

  @media screen and (max-width: 321px){
    .Search\\&Options_selector__jQWgY{
        font-size: 10px;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/Search&Options/Search&Options.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;QACnB,UAAU;QACV,aAAa;QACb,6BAA6B;QAC7B,mBAAmB;QACnB,+BAA+B;QAC/B,yBAAyB;QACzB,uBAAuB;QACvB,WAAW;;IAEf;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,YAAY;QACZ,6BAA6B;QAC7B,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,eAAe;;QAEf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,aAAa;QACb,eAAe;QACf,UAAU;QACV,6BAA6B;IACjC;;IAEA;MACE,YAAY;MACZ,eAAe;IACjB;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,kBAAkB;QAClB,YAAY;QACZ,6BAA6B;QAC7B,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,eAAe;IACnB;;AAEJ;;EAEE;MACI,aAAa;EACjB;;EAEA;MACI;UACI,gBAAgB;UAChB,mBAAmB;UACnB,UAAU;UACV,aAAa;UACb,6BAA6B;UAC7B,mBAAmB;UACnB,+BAA+B;UAC/B,yBAAyB;UACzB,uBAAuB;UACvB,WAAW;;MAEf;;MAEA;UACI,sBAAsB;UACtB,kBAAkB;UAClB,YAAY;UACZ,6BAA6B;UAC7B,gBAAgB;UAChB,YAAY;UACZ,iBAAiB;UACjB,eAAe;;UAEf,gBAAgB;MACpB;;MAEA;UACI,eAAe;UACf,uBAAuB;UACvB,aAAa;UACb,eAAe;UACf,UAAU;UACV,6BAA6B;MACjC;;MAEA;QACE,YAAY;QACZ,eAAe;MACjB;;MAEA;UACI,yBAAyB;UACzB,YAAY;UACZ,aAAa;UACb,UAAU;UACV,kBAAkB;UAClB,YAAY;UACZ,6BAA6B;UAC7B,uBAAuB;MAC3B;;MAEA;UACI,UAAU;UACV,cAAc;MAClB;;MAEA;UACI,kBAAkB;UAClB,YAAY;UACZ,eAAe;MACnB;;EAEJ;;EAEA;IACE;QACI,eAAe;IACnB;EACF","sourcesContent":[".inputMain img {\n    display: none;\n}\n\n@media screen and (max-width: 768px) {\n    .inputMain {\n        padding: 3px 5px;\n        border-radius: 10px;\n        width: 48%;\n        display: flex;\n        justify-content: space-around;\n        align-items: center;\n        /* background-color: #0094ff; */\n        background-color: inherit;\n        border: 1px solid black;\n        margin: 2px;\n\n    }\n\n    .inputTypeDate {\n        border: 1px solid #aaa;\n        border-radius: 3px;\n        padding: 5px;\n        background-color: transparent;\n        margin-left: 3px;\n        border: none;\n        /* width: 29px; */\n        font-size: 13px;\n       \n        background: blue;\n    }\n\n    .selector {\n        margin-top: 5px;\n        border: 1px solid black;\n        outline: none;\n        font-size: 13px;\n        width: 48%;\n        margin-bottom: 0px !important;\n    }\n\n    .date{\n      color: black;\n      font-size: 13px;\n    }\n\n    .inputMain input {\n        background-color: inherit;\n        border: none;\n        outline: none;\n        width: 90%;\n        /* color: white; */\n        color: black;\n        margin-bottom: 0px !important;\n        padding: 0px !important;\n    }\n\n    .inputMain img {\n        width: 11%;\n        display: block;\n    }\n\n    .inputMain input::placeholder {\n        /* color: white; */\n        color: black;\n        font-size: 11px;\n    }\n\n}\n\n  .inputMain img {\n      display: none;\n  }\n\n  @media screen and (max-width: 768px) {\n      .inputMain {\n          padding: 3px 5px;\n          border-radius: 10px;\n          width: 48%;\n          display: flex;\n          justify-content: space-around;\n          align-items: center;\n          /* background-color: #0094ff; */\n          background-color: inherit;\n          border: 1px solid black;\n          margin: 2px;\n\n      }\n\n      .inputTypeDate {\n          border: 1px solid #aaa;\n          border-radius: 3px;\n          padding: 5px;\n          background-color: transparent;\n          margin-left: 3px;\n          border: none;\n          /* width: 29px; */\n          font-size: 13px;\n         \n          background: blue;\n      }\n\n      .selector {\n          margin-top: 5px;\n          border: 1px solid black;\n          outline: none;\n          font-size: 12px;\n          width: 48%;\n          margin-bottom: 0px !important;\n      }\n\n      .date{\n        color: black;\n        font-size: 13px;\n      }\n\n      .inputMain input {\n          background-color: inherit;\n          border: none;\n          outline: none;\n          width: 90%;\n          /* color: white; */\n          color: black;\n          margin-bottom: 0px !important;\n          padding: 0px !important;\n      }\n\n      .inputMain img {\n          width: 10%;\n          display: block;\n      }\n\n      .inputMain input::placeholder {\n          /* color: white; */\n          color: black;\n          font-size: 11px;\n      }\n\n  }\n\n  @media screen and (max-width: 321px){\n    .selector{\n        font-size: 10px;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputMain": `Search&Options_inputMain__bI4tC`,
	"inputTypeDate": `Search&Options_inputTypeDate__oF8H7`,
	"selector": `Search&Options_selector__jQWgY`,
	"date": `Search&Options_date__WawNV`
};
export default ___CSS_LOADER_EXPORT___;
